      <nav [hidden]="!showHeader" *ngIf="authService.isAuthenticatedUser()" class="border-b-2 px-12 shadow-md flex flex-wrap items-center lg:py-2 py-2">
        <div class="flex-1 flex justify-between items-center">
          <a routerLink="" routerLinkActive="active" class="flex text-lg font-semibold">
            <h1><img class="m-auto w-16" alt="logo OPVS GROUP" src="/assets/images/Logo_OPVS_GROUP.jpg"></h1>
          </a>
          <span *ngIf="profileService.user">Benvenuto {{profileService.user.first_name}}</span>
        </div>
        <label for="menu-toggle" class="cursor-pointer lg:hidden block">
          <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
            viewBox="0 0 20 20">
            <title>menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
          </svg>
        </label>
        <input class="hidden" type="checkbox" id="menu-toggle" />
        <div class="hidden lg:flex lg:items-center lg:w-auto w-full" id="menu">
          <nav class="bg-transparent">
            <ul class="text-xl text-center items-center gap-x-5 pt-4 md:gap-x-4 lg:text-lg lg:flex  lg:pt-0 ml-auto">
              <li class="py-2 lg:py-0 " *ngIf="authService.isAuthenticatedUser()">
                <a class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug hover:opacity-75"
                  href="#" routerLink="/progetti" routerLinkActive="active">
                  <fa-icon [icon]="faTarp"></fa-icon>
                  <span class="ml-2">Progetti</span>
                </a>
              </li>
              <li class="py-2 lg:py-0 " *ngIf="!authService.isAuthenticatedUser()">
                <a class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug hover:opacity-75"
                  routerLink="/login" routerLinkActive="active">
                  <fa-icon [icon]="faArrowRightToBracket"></fa-icon>
                  <span class="ml-2">Entra</span>
                </a>
              </li>
              <li class="py-2 lg:py-0 " *ngIf="authService.isAuthenticatedUser()">
                <a class="px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug hover:opacity-75"
                  routerLink="/login" routerLinkActive="active" (click)="logOut()">
                  <fa-icon [icon]="faArrowRightFromBracket"></fa-icon>
                  <span class="ml-2">Esci</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </nav>
